var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { Icon } from "../../UI";
import { FeatureToggle } from "../../components/Elements/FeatureToggle";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { tocGenerationActions } from "./actions";






const mapDispatchToProps = (dispatch) =>
bindActionCreators({ onClick: tocGenerationActions.reviewToc }, dispatch);

const connector = connect(null, mapDispatchToProps);




const ReviewTocButton = ({ file, onClick, children }) => /*#__PURE__*/
_jsx(FeatureToggle, { feature: "tocGeneration" }, void 0,
file.generatedToc && /*#__PURE__*/
_jsx("button", { type: "button", onClick: () => onClick(file._id), className: "edit-toc btn btn-success" }, void 0, /*#__PURE__*/
_jsx(Icon, { icon: "tasks" }), /*#__PURE__*/
_jsx("span", { className: "btn-label" }, void 0, children)
)

);


const container = connector(ReviewTocButton);
export { container as ReviewTocButton };